import React from 'react';

interface FacilityIconProps {
  src?: string;
  alt?: string;
}

const FacilitiesIconHeader: React.FC<FacilityIconProps> = ({ src , alt = "Avatar" }) => {
  return (
    <div className="symbol symbol-30px">
      <img
        src={(process.env.REACT_APP_API_URL_IMAGE || '') + src}
        alt={alt}
        className="rounded-circle"
      />
    </div>
  );
};

export { FacilitiesIconHeader };